// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ejco","comment":"styles_comment__2t2ST"};